module.exports = __webpack_public_path__ + "img/logo.5211e915.png";